import { render } from "./loginpage.vue?vue&type=template&id=9b011a08&scoped=true"
import script from "./loginpage.vue?vue&type=script&lang=js"
export * from "./loginpage.vue?vue&type=script&lang=js"

import "./loginpage.vue?vue&type=style&index=0&id=9b011a08&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b011a08"]])

export default __exports__